import { AppSuccess } from './AppSuccess';
import { Syncable } from './Syncable';
import { User_Base } from './User';
import { Workspace_Base } from './Workspace';
import { SoftDelete } from './SoftDelete';
import { StrapiModel_Base } from './StrapiModel';
import { Organization_Base } from './Organization';

export enum IProjectType {
  COLLECT = 'COLLECT',
  PORTAL = 'PORTAL',
  BLOG = 'BLOG',
  SHOP = 'SHOP',
}

export type Project_Base = StrapiModel_Base &
  Syncable &
  SoftDelete & {
    name: string;
    description: string;
    type: IProjectType;
    boundingBox: string; // "[[95.08949759546255,9.771644531595157],[116.15467121245018,24.9616158076427]]"
    homepage: string;
    createdAt?: string;
    updatedAt?: string;
    isPublished?: boolean;
    avatar?: File | any;
    image?: File | any;
    owner?: User_Base;
    workspace?: Workspace_Base;
    portal_api_base_url?: string;
    organization?: Organization_Base;
  };

export type CreateProject_Request = {
  name: string;
  description: string;
  type: IProjectType;
  workspaceId?: number;
  organizationId?: number;
};

export type CreateProject_Response = AppSuccess<Project_Base>;

export type UpdateProject_Request = {
  name?: string;
  description?: string;
  homepage?: string;
  boundingBox?: string;
  isPublished?: boolean;
  image?: File;
  avatar?: File;
  portal_api_base_url?: string;
  organizationId?: number;
};

export type UpdateProject_Response = AppSuccess<Project_Base>;
